import { useEffect, useMemo } from "react";
import { HOME_PAGE_MAX_SOW_SECTION } from "../../../../../../applications/constants/AppConst";
import {
  ItemBestSellerModel,
  ItemModel,
} from "../../../../../../infrastructure/model/ProductItemModel";
import "../../styles/BestSellerSection.scss";
import ViewAllButton from "./ViewAllButton";

interface BestSellerSectionProps {
  items: ItemModel[];
  itemBestSeller: ItemBestSellerModel[];
  onAdd: (item: ItemModel) => void;
  onShowAll?: (val: string) => void;
  sectionKey: string;
  isShowAll?: boolean;
}

function BestSellerSection(props: BestSellerSectionProps) {
  const { items, onAdd, itemBestSeller, sectionKey, onShowAll, isShowAll = false } = props;

  const cupMap = useMemo(() => {
    const map = new Map<number, number>();
    itemBestSeller.forEach((b) => {
      map.set(b.item_id, b.cup);
    });
    return map;
  }, [itemBestSeller]);

  const sortedItems = useMemo(() => {
    return [...items].sort((a, b) => {
      const cupA = cupMap.get(a.id) ?? 0;
      const cupB = cupMap.get(b.id) ?? 0;
      return cupB - cupA; // lớn → bé
    });
  }, [items, cupMap]);

  const showItems = isShowAll ? sortedItems : sortedItems.slice(0, HOME_PAGE_MAX_SOW_SECTION);

  useEffect(() => {
    document.getElementById("content_scrollable_app_element")?.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <section className={`best-seller-section mt-3 mb-3`}>
      {/* HEADER */}
      <div className="section-header">
        <h2>
          <span className="section-icon">🔥</span>
          BEST SELLER
        </h2>

        <span className="best-tag">TOP BÁN CHẠY</span>
      </div>

      {/* SUB TITLE */}
      <p className="best-subtitle">Những sản phẩm được khách hàng lựa chọn nhiều nhất</p>

      {/* CONTENT */}
      <div className="section-content">
        <div className="products-grid">
          {showItems.map((item, index) => {
            const amount = cupMap.get(item.id) ?? 492;
            return (
              <div key={item.id} className="product-card best-card">
                <div className="image-wrapper">
                  <img src={item.image} alt={item.name} />
                  <button className="add-btn" onClick={() => onAdd(item)}>
                    +
                  </button>
                </div>

                <div className="product-info">
                  <h4>{item.name}</h4>

                  <div className="best-meta">
                    <span className="sold-count">🔥 Đã bán {amount}+</span>
                  </div>

                  <span className="price">{item.size_mapping?.[0]?.price?.toLocaleString()}đ</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {items.length > HOME_PAGE_MAX_SOW_SECTION && !isShowAll && (
        <ViewAllButton
          onClick={() => onShowAll?.(sectionKey)}
          highlight="best" // hoặc "best" | "normal"
          label="Khám phá Best Seller"
        />
      )}
    </section>
  );
}

export default BestSellerSection;
